import * as Yup from 'yup';
import { UserReplacement, UserRole } from '@models';

export function useValidationSchema() {
  return Yup.object<UserReplacement>().shape({
    role: Yup.mixed<UserRole>().nullable().required(),
    replacingUser: Yup.mixed<UserRole>().nullable().required(),
  });
}
